import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import {
  FORM_ID,
  FormValues,
  TOAST_SUCCESS_MESSAGE,
  TOAST_ERROR_MESSAGE,
} from './UnlinkAndDeleteModal.meta';
import { Checkbox } from '../../../CommonComponents/OPL/Checkbox/Checkbox';
import { toast } from '../../../CommonComponents/OPL/Toast/Toast';
import { useUnlinkOrionConsumerMutation } from '../../api/useUnlinkOrionConsumerMutation';

export const UnlinkAndDeleteModalForm = () => {
  const { mutateAsync: unlinkOrionConsumer } = useUnlinkOrionConsumerMutation();

  const onSubmit = async (values: FormValues) => {
    try {
      const { deleteAccountsFromHousehold } = values;

      await unlinkOrionConsumer(deleteAccountsFromHousehold);

      toast.success(TOAST_SUCCESS_MESSAGE);
    } catch (err) {
      console.error(err);
      toast.error(TOAST_ERROR_MESSAGE);
    }
  };

  const formBag = useForm<FormValues>({
    defaultValues: {
      deleteAccountsFromHousehold: false,
    },
  });

  return (
    <FormProvider {...formBag}>
      <form id={FORM_ID} onSubmit={formBag.handleSubmit(onSubmit)}>
        <Checkbox mt="8" {...formBag.register('deleteAccountsFromHousehold')}>
          Remove the Orion linked accounts from the system as well.
        </Checkbox>
      </form>
    </FormProvider>
  );
};
